import { useFormContext } from 'react-hook-form';
import { TextInput } from '@/components/form/TextInput.tsx';
import ColorInput from '@/components/form/ColorInput.tsx';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import { colorPresets } from '@/components/form/colorPresets.ts';
import { TagFormInput } from '@/features/dashboard/tags/schemas/tagSchema.ts';
import TagChip from '@/features/dashboard/tags/components/TagChip.tsx';
import { DEFAULT_TAG_COLOR } from '@/features/dashboard/tags/types/tagColor.utils.ts';

const TagForm = () => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext<TagFormInput>();

  const name = watch('name');
  const color = watch('color');

  return (
    <div className="flex flex-col gap-4">
      <TextInput
        label="Nazwa"
        required
        placeholder="np. VIP"
        register={register('name')}
        error={errors.name?.message}
      />

      <ColorInput
        label="Kolor"
        required
        fieldPath="color"
        control={control}
        presets={colorPresets}
        error={errors.color?.message}
        fallbackColor={DEFAULT_TAG_COLOR}
      />

      <div className="flex flex-col gap-1.5">
        <InputLabel label="Podgląd" />
        <TagChip
          tag={{
            name: name?.trim() || 'Nazwa tagu',
            color: color || DEFAULT_TAG_COLOR,
          }}
        />
      </div>
    </div>
  );
};

export default TagForm;
